import { __awaiter, __generator } from "tslib";
export default [
    {
        id: '@mc-cluster-list',
        path: '/mc-cluster-list',
        ref: '/',
        onload: function () { return import('./ClusterListView'); },
        onbefore: function (app) { return __awaiter(void 0, void 0, void 0, function () {
            var modelList;
            return __generator(this, function (_a) {
                modelList = require('./model').modelList;
                app.collection.register(modelList);
                return [2];
            });
        }); },
    }
];
